import { GlobeIcon } from 'lucide-react';
import { type FlagProps, type Labels } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import labelsDe from 'react-phone-number-input/locale/de';
import labelsEn from 'react-phone-number-input/locale/en';
import labelsFr from 'react-phone-number-input/locale/fr';
import labelsNl from 'react-phone-number-input/locale/nl';

const FLAG_CLASSNAME = [
  'flex size-5 items-center justify-center',
  "[&_svg:not([class*='size-'])]:size-full! [&_svg:not([class*='size-'])]:rounded-sm",
].join(' ');

const COUNTRY_LABELS_BY_LANGUAGE: Record<string, Labels> = {
  de: labelsDe,
  en: labelsEn,
  fr: labelsFr,
  nl: labelsNl,
};

export const getCountryLabels = (locale: string): Labels => {
  const [language] = locale.split('-');
  return COUNTRY_LABELS_BY_LANGUAGE[language] ?? labelsEn;
};

export const CountryFlag = ({ country, countryName }: FlagProps) => {
  const Flag = flags[country];
  return (
    <span data-slot="country-flag" className={FLAG_CLASSNAME}>
      {Flag ? <Flag title={countryName} /> : <GlobeIcon className="size-4 opacity-60" />}
    </span>
  );
};
